<div class="page-banner bg-7">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Rate and Transit Times</h2>
                    <!-- <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Air fright</li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="Rate-transit py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
                <div class="card border-1 shadow-sm rounded-4">
                    <div class="card-body p-4 p-md-5">
                        <form method="post" action="">
                            <div class="text-center mb-5">
                                <h1 class="h2 fw-bold mb-3">Rate and Transit Times</h1>
                                <p class="text-muted mb-0">We help you choose the best deal for your package! Compare the shipping rates, transit times across our
                                    service affiliates. Simply enter the details and get all the information you need.</p>
                            </div>

                            <div class="row g-4">
                                <div class="col-12 col-lg-6">
                                    <div class="border rounded-4 p-4 h-100 bg-light">
                                        <h5 class="fw-bold mb-4">Shipper Details</h5>
                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Shipper Zip Code <span style="color:red">*</span></label>
                                            <input type="number" (wheel)="stopScrollingWheel($event)" class="form-control"
                                                name="shipper_zip" id="shipper_zip" placeholder="Enter Shipper Zip" required="">
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Shipper Country <span style="color:red">*</span></label>
                                            <mat-form-field appearance="outline" class="w-100">
                            <mat-select name="shippper_country" id="shippper_country" required="">
                                <mat-option value="United States">United States</mat-option>
                            </mat-select>
                        </mat-form-field>
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Package Type <span style="color:red">*</span></label>
                                            <mat-form-field appearance="outline" class="w-100">
                            <mat-select name="shipper_pkg" id="shipper_pkg" required="" [(ngModel)]="shipperPkg">
                                <mat-option value="Document">Document</mat-option>
                                <mat-option value="Package">Package</mat-option>
                            </mat-select>
                        </mat-form-field>
                                        </div>
                                        <div class="mb-0">
                                            <label class="form-label fw-semibold">Weight <span style="color:red">*</span></label>
                                            <div class="row g-2">
                                                <div class="col-sm-7">
                                                    <input type="number" (wheel)="stopScrollingWheel($event)" name="weight" id="weight"
                                                        class="form-control" placeholder="0" required="">
                                                </div>
                                                <div class="col-sm-5">
                                                    <mat-form-field appearance="outline" class="w-100">
                            <mat-select name="weight_type" id="weight_type" [(ngModel)]="weightType">
                                <mat-option value="Kg">Kg</mat-option>
                                <mat-option value="Lbs">Lbs</mat-option>
                            </mat-select>
                        </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-6">
                                    <div class="border rounded-4 p-4 h-100">
                                        <h5 class="fw-bold mb-4">Receiver Details</h5>
                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Receiver Zip Code <span style="color:red">*</span></label>
                                            <input type="number" (wheel)="stopScrollingWheel($event)" name="receiver_zip" id="receiver_zip"
                                                class="form-control" required="" placeholder="Enter Shipper Zip">
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Receiver Country <span style="color:red">*</span></label>
                                            <mat-form-field appearance="outline" class="w-100">
                            <mat-select name="receiver_country" id="receiver_country" required="" placeholder="Select">
                            <mat-option value="">Select</mat-option>
                            <mat-option value="2">Afghanistan</mat-option>
                            <mat-option value="3">Albania</mat-option>
                            <mat-option value="4">Algeria</mat-option>
                            <mat-option value="5">American Samoa</mat-option>
                            <mat-option value="6">Andorra</mat-option>
                            <mat-option value="7">Angola</mat-option>
                            <mat-option value="8">Anguilla</mat-option>
                            <mat-option value="9">Antigua And Barbuda</mat-option>
                            <mat-option value="10">Argentina</mat-option>
                            <mat-option value="11">Armenia</mat-option>
                            <mat-option value="12">Aruba</mat-option>
                            <mat-option value="13">Australia</mat-option>
                            <mat-option value="14">Austria</mat-option>
                            <mat-option value="15">Azerbaijan</mat-option>
                            <mat-option value="16">Bahamas</mat-option>
                            <mat-option value="17">Bahrain</mat-option>
                            <mat-option value="18">Bangladesh</mat-option>
                            <mat-option value="19">Barbados</mat-option>
                            <mat-option value="20">Belarus</mat-option>
                            <mat-option value="21">Belgium</mat-option>
                            <mat-option value="22">Belize</mat-option>
                            <mat-option value="23">Benin</mat-option>
                            <mat-option value="24">Bermuda</mat-option>
                            <mat-option value="25">Bhutan</mat-option>
                            <mat-option value="26">Bolivia</mat-option>
                            <mat-option value="240">Bonaire</mat-option>
                            <mat-option value="27">Bosnia And Herzegovina</mat-option>
                            <mat-option value="28">Botswana</mat-option>
                            <mat-option value="29">Bouvet Island</mat-option>
                            <mat-option value="30">Brazil</mat-option>
                            <mat-option value="31">British Indian Ocean Territory</mat-option>
                            <mat-option value="239">Brunei</mat-option>
                            <mat-option value="32">Brunei Darussalam</mat-option>
                            <mat-option value="33">Bulgaria</mat-option>
                            <mat-option value="34">Burkina Faso</mat-option>
                            <mat-option value="35">Burundi</mat-option>
                            <mat-option value="36">Cambodia</mat-option>
                            <mat-option value="37">Cameroon</mat-option>
                            <mat-option value="38">Canada</mat-option>
                            <mat-option value="241">Canary Islands, The</mat-option>
                            <mat-option value="39">Cape Verde</mat-option>
                            <mat-option value="40">Cayman Islands</mat-option>
                            <mat-option value="41">Central African Republic</mat-option>
                            <mat-option value="42">Chad</mat-option>
                            <mat-option value="43">Chile</mat-option>
                            <mat-option value="44">China</mat-option>
                            <mat-option value="45">Christmas Island</mat-option>
                            <mat-option value="46">Cocos (Keeling) Islands</mat-option>
                            <mat-option value="47">Colombia</mat-option>
                            <mat-option value="48">Comoros</mat-option>
                            <mat-option value="49">Congo</mat-option>
                            <mat-option value="262">Congo, DPR</mat-option>
                            <mat-option value="50">Cook Islands</mat-option>
                            <mat-option value="51">Costa Rica</mat-option>
                            <mat-option value="242">Costa Rica</mat-option>
                            <mat-option value="52">Cote D'Ivoire</mat-option>
                            <mat-option value="53">Croatia</mat-option>
                            <mat-option value="54">Cuba</mat-option>
                            <mat-option value="243">Curacao</mat-option>
                            <mat-option value="55">Cyprus</mat-option>
                            <mat-option value="56">Czech Republic</mat-option>
                            <mat-option value="57">Czechoslovakia</mat-option>
                            <mat-option value="58">Denmark</mat-option>
                            <mat-option value="59">Djibouti</mat-option>
                            <mat-option value="60">Dominica</mat-option>
                            <mat-option value="61">Dominican Republic</mat-option>
                            <mat-option value="62">East Timor</mat-option>
                            <mat-option value="63">Ecuador</mat-option>
                            <mat-option value="64">Egypt</mat-option>
                            <mat-option value="65">El Salvador</mat-option>
                            <mat-option value="66">Equatorial Guinea</mat-option>
                            <mat-option value="67">Eritrea</mat-option>
                            <mat-option value="68">Estonia</mat-option>
                            <mat-option value="69">Ethiopia</mat-option>
                            <mat-option value="70">Falkland Islands (Malvinas)</mat-option>
                            <mat-option value="71">Faroe Islands</mat-option>
                            <mat-option value="72">Fiji</mat-option>
                            <mat-option value="73">Finland</mat-option>
                            <mat-option value="74">France</mat-option>
                            <mat-option value="75">French Guiana</mat-option>
                            <mat-option value="76">French Polynesia</mat-option>
                            <mat-option value="77">French Southern Territories</mat-option>
                            <mat-option value="78">Gabon</mat-option>
                            <mat-option value="79">Gambia</mat-option>
                            <mat-option value="80">Georgia</mat-option>
                            <mat-option value="81">Germany</mat-option>
                            <mat-option value="82">Ghana</mat-option>
                            <mat-option value="83">Gibraltar</mat-option>
                            <mat-option value="84">Greece</mat-option>
                            <mat-option value="85">Greenland</mat-option>
                            <mat-option value="86">Grenada</mat-option>
                            <mat-option value="87">Guadeloupe</mat-option>
                            <mat-option value="88">Guam</mat-option>
                            <mat-option value="89">Guatemala</mat-option>
                            <mat-option value="245">Guernsey</mat-option>
                            <mat-option value="90">Guinea</mat-option>
                            <mat-option value="91">Guinea-bissau</mat-option>
                            <mat-option value="244">Guinea-Equatorial</mat-option>
                            <mat-option value="92">Guyana</mat-option>
                            <mat-option value="93">Haiti</mat-option>
                            <mat-option value="94">Heard And Mcdonald Islands</mat-option>
                            <mat-option value="237">Holland</mat-option>
                            <mat-option value="95">Honduras</mat-option>
                            <mat-option value="96">Hong Kong</mat-option>
                            <mat-option value="97">Hungary</mat-option>
                            <mat-option value="98">Iceland</mat-option>
                            <mat-option value="1">India</mat-option>
                            <mat-option value="100">Indonesia</mat-option>
                            <mat-option value="101">Iraq</mat-option>
                            <mat-option value="102">Ireland</mat-option>
                            <mat-option value="103">Islamic Republic Of Iran</mat-option>
                            <mat-option value="104">Israel</mat-option>
                            <mat-option value="105">Italy</mat-option>
                            <mat-option value="106">Jamaica</mat-option>
                            <mat-option value="107">Japan</mat-option>
                            <mat-option value="246">Jersey</mat-option>
                            <mat-option value="108">Jordan</mat-option>
                            <mat-option value="109">Kazakhstan</mat-option>
                            <mat-option value="110">Kenya</mat-option>
                            <mat-option value="111">Kiribati</mat-option>
                            <mat-option value="248">Korea, Rep. Of</mat-option>
                            <mat-option value="247">Korea, &nbsp;D.P.R Of</mat-option>
                            <mat-option value="249">Kosovo</mat-option>
                            <mat-option value="113">Kuwait</mat-option>
                            <mat-option value="114">Kyrgyzstan</mat-option>
                            <mat-option value="115">Laos</mat-option>
                            <mat-option value="116">Latvia</mat-option>
                            <mat-option value="117">Lebanon</mat-option>
                            <mat-option value="118">Lesotho</mat-option>
                            <mat-option value="119">Liberia</mat-option>
                            <mat-option value="120">Libyan Arab Jamahiriya</mat-option>
                            <mat-option value="121">Liechtenstein</mat-option>
                            <mat-option value="122">Lithuania</mat-option>
                            <mat-option value="123">Luxembourg</mat-option>
                            <mat-option value="124">Macau</mat-option>
                            <mat-option value="125">Macedonia</mat-option>
                            <mat-option value="126">Madagascar</mat-option>
                            <mat-option value="127">Malawi</mat-option>
                            <mat-option value="128">Malaysia</mat-option>
                            <mat-option value="129">Maldives</mat-option>
                            <mat-option value="130">Mali</mat-option>
                            <mat-option value="131">Malta</mat-option>
                            <mat-option value="250">Mariana Islands</mat-option>
                            <mat-option value="132">Marshall Islands</mat-option>
                            <mat-option value="133">Martinique</mat-option>
                            <mat-option value="134">Mauritania</mat-option>
                            <mat-option value="135">Mauritius</mat-option>
                            <mat-option value="136">Mayotte</mat-option>
                            <mat-option value="137">Mexico</mat-option>
                            <mat-option value="138">Micronesia</mat-option>
                            <mat-option value="139">Moldova</mat-option>
                            <mat-option value="140">Monaco</mat-option>
                            <mat-option value="141">Mongolia</mat-option>
                            <mat-option value="142">Montenegro</mat-option>
                            <mat-option value="143">Montserrat</mat-option>
                            <mat-option value="144">Morocco</mat-option>
                            <mat-option value="145">Mozambique</mat-option>
                            <mat-option value="146">Myanmar</mat-option>
                            <mat-option value="147">Namibia</mat-option>
                            <mat-option value="148">Nauru</mat-option>
                            <mat-option value="149">Nepal</mat-option>
                            <mat-option value="150">Netherlands</mat-option>
                            <mat-option value="151">Netherlands Antilles</mat-option>
                            <mat-option value="251">Nevis</mat-option>
                            <mat-option value="152">New Caledonia</mat-option>
                            <mat-option value="153">New Zealand</mat-option>
                            <mat-option value="154">Nicaragua</mat-option>
                            <mat-option value="155">Niger</mat-option>
                            <mat-option value="156">Nigeria</mat-option>
                            <mat-option value="157">Niue</mat-option>
                            <mat-option value="158">Norfolk Island</mat-option>
                            <mat-option value="159">Northern Mariana Islands</mat-option>
                            <mat-option value="160">Norway</mat-option>
                            <mat-option value="161">Oman</mat-option>
                            <mat-option value="162">Pakistan</mat-option>
                            <mat-option value="163">Palau</mat-option>
                            <mat-option value="164">Panama</mat-option>
                            <mat-option value="165">Papua New Guinea</mat-option>
                            <mat-option value="166">Paraguay</mat-option>
                            <mat-option value="167">Peru</mat-option>
                            <mat-option value="168">Philippines</mat-option>
                            <mat-option value="169">Pitcairn</mat-option>
                            <mat-option value="170">Poland</mat-option>
                            <mat-option value="171">Portugal</mat-option>
                            <mat-option value="172">Puerto Rico</mat-option>
                            <mat-option value="173">Qatar</mat-option>
                            <mat-option value="174">Reunion</mat-option>
                            <mat-option value="175">Romania</mat-option>
                            <mat-option value="176">Russian Federation</mat-option>
                            <mat-option value="177">Rwanda</mat-option>
                            <mat-option value="238">Saba</mat-option>
                            <mat-option value="252">Saint Helena</mat-option>
                            <mat-option value="178">Saint Lucia</mat-option>
                            <mat-option value="179">Samoa</mat-option>
                            <mat-option value="180">San Marino</mat-option>
                            <mat-option value="181">Sao Tome And Principe</mat-option>
                            <mat-option value="182">Saudi Arabia</mat-option>
                            <mat-option value="183">Senegal</mat-option>
                            <mat-option value="236">Serbia</mat-option>
                            <mat-option value="184">Seychelles</mat-option>
                            <mat-option value="185">Sierra Leone</mat-option>
                            <mat-option value="186">Singapore</mat-option>
                            <mat-option value="187">Slovakia</mat-option>
                            <mat-option value="188">Slovenia</mat-option>
                            <mat-option value="189">Solomon Islands</mat-option>
                            <mat-option value="190">Somalia</mat-option>
                            <mat-option value="253">Somaliland, Rep Of</mat-option>
                            <mat-option value="191">South Africa</mat-option>
                            <mat-option value="112">South Korea</mat-option>
                            <mat-option value="254">South Sudan</mat-option>
                            <mat-option value="192">Spain</mat-option>
                            <mat-option value="193">Sri Lanka</mat-option>
                            <mat-option value="255">St. Barthelemy</mat-option>
                            <mat-option value="256">St. Eustatius</mat-option>
                            <mat-option value="194">St. Helena</mat-option>
                            <mat-option value="195">St. Kitts And Nevis</mat-option>
                            <mat-option value="257">St. Lucia</mat-option>
                            <mat-option value="258">St. Maarten</mat-option>
                            <mat-option value="196">St. Pierre And Miquelon</mat-option>
                            <mat-option value="259">St. Vincent</mat-option>
                            <mat-option value="197">Sudan</mat-option>
                            <mat-option value="198">Suriname</mat-option>
                            <mat-option value="199">Svalbard And Jan Mayen Islands</mat-option>
                            <mat-option value="200">Swaziland</mat-option>
                            <mat-option value="201">Sweden</mat-option>
                            <mat-option value="202">Switzerland</mat-option>
                            <mat-option value="203">Syrian Arab Republic</mat-option>
                            <mat-option value="260">Tahiti</mat-option>
                            <mat-option value="204">Taiwan</mat-option>
                            <mat-option value="205">Tajikistan</mat-option>
                            <mat-option value="206">Tanzania</mat-option>
                            <mat-option value="207">Thailand</mat-option>
                            <mat-option value="208">Togo</mat-option>
                            <mat-option value="209">Tokelau</mat-option>
                            <mat-option value="210">Tonga</mat-option>
                            <mat-option value="211">Trinidad And Tobago</mat-option>
                            <mat-option value="212">Tunisia</mat-option>
                            <mat-option value="213">Turkey</mat-option>
                            <mat-option value="214">Turkmenistan</mat-option>
                            <mat-option value="215">Turks And Caicos Islands</mat-option>
                            <mat-option value="216">Tuvalu</mat-option>
                            <mat-option value="217">Uganda</mat-option>
                            <mat-option value="218">Ukraine</mat-option>
                            <mat-option value="219">United Arab Emirates</mat-option>
                            <mat-option value="220">United Kingdom</mat-option>
                            <mat-option value="221">United States</mat-option>
                            <mat-option value="222">United States Minor Outlying Islands</mat-option>
                            <mat-option value="223">Uruguay</mat-option>
                            <mat-option value="224">Uzbekistan</mat-option>
                            <mat-option value="225">Vanuatu</mat-option>
                            <mat-option value="261">Vatican City</mat-option>
                            <mat-option value="226">Venezuela</mat-option>
                            <mat-option value="227">Vietnam</mat-option>
                            <mat-option value="228">Virgin Islands</mat-option>
                            <mat-option value="229">Virgin Islands</mat-option>
                            <mat-option value="230">Wallis And Futuna</mat-option>
                            <mat-option value="231">Western Sahara</mat-option>
                            <mat-option value="232">Yemen</mat-option>
                            <mat-option value="233">Yugoslavia</mat-option>
                            <mat-option value="234">Zambia</mat-option>
                            <mat-option value="235">Zimbabwe</mat-option>
                            </mat-select>
                        </mat-form-field>
                                        </div>
                                        <div class="mb-0">
                                            <label class="form-label fw-semibold">Dimensions (In inch) <span style="color:red">*</span></label>
                                            <div class="row g-2">
                                                <div class="col-md-4">
                                                    <input type="number" (wheel)="stopScrollingWheel($event)" name="length" id="length"
                                                        class="form-control" placeholder="Length" required="">
                                                </div>
                                                <div class="col-md-4">
                                                    <input type="number" (wheel)="stopScrollingWheel($event)" class="form-control" name="width"
                                                        id="width" placeholder="Width" required="">
                                                </div>
                                                <div class="col-md-4">
                                                    <input type="number" (wheel)="stopScrollingWheel($event)" name="height" id="height"
                                                        class="form-control" placeholder="Heigth" required="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center mt-4">
                                <button type="submit" name="getRate" class="btn btn-blink">
                                    <span>Get Rates</span>
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="newsletter-area">
    <div class="container">
        <div class="newsletter-content">
            <div class="row align-items-center">
                <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and logistic industry</p>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required=""
                            autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</div>
